import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = {
  key: 0,
  class: "max-w-md mx-auto mb-6 flex items-center justify-between gap-4 p-4 text-accent-700 border rounded-lg border-accent-200 bg-accent-50",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-3\"><span class=\"p-2 text-white bg-accent-600 rounded-full\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"w-5 h-5\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></span><p><strong class=\"text-sm font-medium\">Account Created!</strong><span class=\"block text-xs opacity-90\"> Sign in below to get started. </span></p></div>", 1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "max-w-md w-full mx-auto" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center mb-8\"><div class=\"flex justify-center mb-4\"><div class=\"w-12 h-12 bg-accent-600 rounded-xl flex items-center justify-center\"><svg class=\"w-7 h-7 text-white\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6\"></path></svg></div></div><h1 class=\"text-2xl font-heading font-bold text-primary-800 sm:text-3xl\"> Welcome Back </h1><p class=\"mt-2 text-primary-500\"> Sign in to the Foxwood Crossing community </p></div>", 1)
const _hoisted_9 = { class: "bg-white rounded-xl border border-primary-200 shadow-card p-8" }
const _hoisted_10 = ["onSubmit"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, " Email ", -1)
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 inline-flex items-center right-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "w-5 h-5 text-primary-400",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
    })
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, " Password ", -1)
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 inline-flex items-center right-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "w-5 h-5 text-primary-400",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    })
  ])
], -1)
const _hoisted_17 = {
  key: 0,
  class: "text-red-600 text-sm bg-red-50 p-3 rounded-lg text-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "w-full px-6 py-3 text-white bg-accent-600 rounded-lg hover:bg-accent-700 transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2"
}, " Sign In ", -1)
const _hoisted_19 = { class: "text-sm text-center text-primary-500 space-y-2 pt-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Don't have an account? ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Sign up ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Forgot your password? ")

import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import { ref, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  from: {
    required: false,
    type: String,
  },
},
  setup(__props) {

const props = __props



const email = ref("");
const password = ref("");
const auth = useAuthStore();
const error = ref("");
const popupDismissed = ref(false);

const showNewAccountPopup = computed(() => {
  return props.from === "new_account";
});

const submit = async () => {
  error.value = "";
  try {
    await auth.login(email.value, password.value);
    router.push("/community");
  } catch (e) {
    error.value = "Invalid email or password";
  }
};

if (auth.loggedIn) {
  router.push("/community");
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showNewAccountPopup) && !popupDismissed.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            class: "text-accent-500 hover:text-accent-700 transition-colors",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (popupDismissed.value = true))
          }, _hoisted_6)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(submit, ["prevent"]),
          class: "space-y-5"
        }, [
          _createElementVNode("div", null, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                type: "email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
                class: "w-full px-4 py-3 pr-12 text-primary-800 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors",
                placeholder: "you@example.com"
              }, null, 512), [
                [_vModelText, email.value]
              ]),
              _hoisted_13
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                id: "password",
                type: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                class: "w-full px-4 py-3 pr-12 text-primary-800 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors",
                placeholder: "Enter your password"
              }, null, 512), [
                [_vModelText, password.value]
              ]),
              _hoisted_16
            ])
          ]),
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", null, [
              _hoisted_20,
              _createVNode(_component_router_link, {
                class: "text-accent-600 hover:text-accent-700 font-medium transition-colors",
                to: "/register"
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              })
            ]),
            _createElementVNode("p", null, [
              _createVNode(_component_router_link, {
                class: "text-accent-600 hover:text-accent-700 transition-colors",
                to: "/password_reset"
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              })
            ])
          ])
        ], 40, _hoisted_10)
      ])
    ])
  ]))
}
}

})